import * as yup from 'yup';

export const initialValues = {
  changeReason: '',
  changeComments: '',
};

export const validationSchema = yup.object().shape({
  changeReason: yup.string(),
  changeComments: yup.string().required('Comments is required'),
});
